import { Pulse, Plus } from "@phosphor-icons/react";
import type {
  FeaturePalette,
  Result,
  ScopeNode,
  SearchProvider,
} from "@/shared/components/command-palette/types";
import { searchInputTypes } from "./api/input-types";

const INPUTS_PARENT: ScopeNode = {
  id: "input-types",
  parentId: null,
  title: "Input Types",
  shortTitle: "Inputs",
};

const inputTypesProvider: SearchProvider = {
  id: "input-types",
  label: "Input Types",
  icon: Pulse,
  prefix: "@inputs",
  async search(q, signal) {
    if (!q) return [];
    try {
      const res = await searchInputTypes(q, 6);
      if (signal.aborted) return [];
      return res.items.map<Result>((it) => ({
        id: `it:${it.id}`,
        title: it.title,
        subtitle: it.description ?? undefined,
        icon: Pulse,
        scopeChain: [INPUTS_PARENT],
        score: 50,
        onSelect: (ctx) => {
          ctx.router.push(`/input-types/${it.id}`);
          ctx.close();
        },
        verbs: [
          {
            id: "input-types.open",
            title: "Open",
            icon: Pulse,
            run: (e, ctx) => {
              ctx.router.push(`/input-types/${(e as { id: string }).id}`);
            },
          },
        ],
        entity: it,
      }));
    } catch {
      return [];
    }
  },
};

export const inputTypesPalette: FeaturePalette = {
  commands: [
    {
      id: "input-types.create",
      title: "Create new input type",
      icon: Plus,
      scopeId: "input-types",
      keywords: ["new", "input", "track", "type"],
      run: (ctx) => ctx.router.push("/input-types?new=true"),
    },
  ],
  searchProviders: [inputTypesProvider],
};
